module.exports = __webpack_public_path__ + "static/img/pro_display_1.7bd2b1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productDisplay/pro_display_1.jpg
// module id = lpWa
// module chunks = 1